export default function FeatureGrid() {
  const features = [
    {
      icon: 'ri-timer-line',
      title: 'Save Research Time',
      description: 'Find organized product information instantly instead of searching through hundreds of scattered pages across multiple platforms.',
    },
    {
      icon: 'ri-fire-line',
      title: 'Discover Trending Products',
      description: 'Explore popular categories and community recommendations curated from the latest Superbuy spreadsheet finds and updates.',
    },
    {
      icon: 'ri-scales-line',
      title: 'Compare Options Easily',
      description: 'Use structured category layouts to compare products side by side and make informed purchasing decisions faster.',
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Shop With Confidence',
      description: 'Learn QC checking methods, understand shipping practices, and follow safety-first approaches for international shopping.',
    },
  ];

  return (
    <section className="w-full py-20 md:py-28 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-14">
          <span className="inline-block px-4 py-1.5 border border-foreground-200 rounded-full text-foreground-500 font-label text-xs font-medium mb-4">
            Why Choose Us
          </span>
          <h2 className="font-heading text-4xl md:text-5xl font-bold text-foreground-950 leading-tight">
            Smarter Shopping<br />
            Starts Here
          </h2>
          <p className="text-foreground-500 text-sm mt-4 max-w-lg mx-auto">
            Thousands of users rely on Superbuy Spreadsheet to streamline their product discovery workflow.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((feature) => (
            <div
              key={feature.title}
              className="group bg-white rounded-2xl p-6 md:p-8 cursor-pointer transition-all duration-300 hover:bg-accent-100"
            >
              <div className="w-12 h-12 rounded-xl bg-background-200 flex items-center justify-center mb-5 group-hover:bg-accent-200 transition-colors duration-300">
                <i className={`${feature.icon} text-xl text-foreground-700 group-hover:text-accent-800 transition-colors duration-300`}></i>
              </div>
              <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-3 group-hover:text-foreground-950 transition-colors duration-300">
                {feature.title}
              </h3>
              <p className="text-foreground-500 text-sm leading-relaxed group-hover:text-foreground-700 transition-colors duration-300">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}